import { render, staticRenderFns } from "./ReplyPanel.vue?vue&type=template&id=89c15864&scoped=true&"
import script from "./ReplyPanel.vue?vue&type=script&lang=js&"
export * from "./ReplyPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReplyPanel.vue?vue&type=style&index=0&id=89c15864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c15864",
  null
  
)

export default component.exports